(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('ka-home-selector')) {
    customElements.define('ka-home-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.range = this.querySelector('[data-ka-range]');
        this.output = this.querySelector('[data-ka-output]');
        this.thumb = this.querySelector('[data-ka-thumb]');
        this.ladder = this.querySelector('[data-ka-swipe-track]');
        this.swipeHint = this.querySelector('[data-ka-swipe-hint]');
        this.swipePrevious = this.swipeHint && this.swipeHint.querySelector('[data-ka-swipe-prev]');
        this.swipeNext = this.swipeHint && this.swipeHint.querySelector('[data-ka-swipe-next]');
        this.swipeStatus = this.swipeHint && this.swipeHint.querySelector('[data-ka-swipe-status]');
        this.cards = Array.from(this.querySelectorAll('[data-ka-product-card]'));
        if (!this.range || !this.output || !this.cards.length) return;

        this.reverse = this.dataset.reverse === 'true';
        this.mobileLayout = window.matchMedia('(max-width: 760px)');
        this.scrollTimer = null;
        this.range.max = String(Math.max(this.cards.length - 1, 0));
        var defaultCard = Math.min(Number(this.dataset.defaultCard || 0), this.cards.length - 1);
        this.range.value = String(this.reverse ? this.cards.length - 1 - defaultCard : defaultCard);

        this.range.addEventListener('input', () => this.apply(true));
        if (this.dataset.hoverPreview === 'true') {
          this.cards.forEach((card, cardIndex) => {
            card.addEventListener('mouseenter', () => {
              this.range.value = String(this.reverse ? this.cards.length - 1 - cardIndex : cardIndex);
              this.apply(false);
            });
          });
        }

        if (this.ladder) {
          this.ladder.addEventListener('scroll', () => {
            if (!this.mobileLayout.matches) return;
            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 90);
          }, { passive: true });
        }

        this.apply(false);
      }

      updateSwipeHint(cardIndex) {
        if (!this.swipeHint) return;
        var hasPrevious = cardIndex > 0;
        var hasNext = cardIndex < this.cards.length - 1;
        if (this.swipePrevious) this.swipePrevious.hidden = !hasPrevious;
        if (this.swipeNext) this.swipeNext.hidden = !hasNext;
        if (this.swipeStatus) {
          var instruction = hasPrevious && hasNext
            ? 'Swipe left or right to view another product.'
            : hasNext
              ? 'Swipe left to view the next product.'
              : 'Swipe right to view the previous product.';
          this.swipeStatus.textContent = 'Product ' + (cardIndex + 1) + ' of ' + this.cards.length + '. ' + instruction;
        }
      }

      scrollToCard(cardIndex) {
        if (!this.ladder || !this.mobileLayout.matches || !this.cards[cardIndex]) return;
        var firstOffset = this.cards[0].offsetLeft;
        this.ladder.scrollTo({
          left: this.cards[cardIndex].offsetLeft - firstOffset,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      syncFromScroll() {
        if (!this.ladder || !this.mobileLayout.matches) return;
        var ladderRect = this.ladder.getBoundingClientRect();
        var ladderCenter = ladderRect.left + ladderRect.width / 2;
        var closestCardIndex = 0;
        var closestDistance = Infinity;
        this.cards.forEach((card, cardIndex) => {
          var cardRect = card.getBoundingClientRect();
          var distance = Math.abs(cardRect.left + cardRect.width / 2 - ladderCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestCardIndex = cardIndex;
          }
        });
        var sliderIndex = this.reverse ? this.cards.length - 1 - closestCardIndex : closestCardIndex;
        if (Number(this.range.value) !== sliderIndex) {
          this.range.value = String(sliderIndex);
          this.apply(false);
        } else {
          this.updateSwipeHint(closestCardIndex);
        }
      }

      apply(scrollCard) {
        var sliderIndex = Number(this.range.value);
        var cardIndex = this.reverse ? this.cards.length - 1 - sliderIndex : sliderIndex;
        var active = this.cards[cardIndex];
        if (!active) return;

        this.cards.forEach((card, index) => {
          card.classList.toggle('win', index === cardIndex);
          card.dataset.selected = index === cardIndex ? 'true' : 'false';
        });

        this.output.replaceChildren();
        var strong = document.createElement('b');
        strong.textContent = active.dataset.concentration || '';
        var note = document.createElement('span');
        note.textContent = active.dataset.priceNote || '';
        this.output.append(strong, document.createTextNode(' ' + (this.dataset.moleculeLabel || '') + ' · '), note);

        if (this.thumb) {
          var lastSliderIndex = Math.max(this.cards.length - 1, 1);
          var sliderProgress = sliderIndex / lastSliderIndex;
          this.thumb.textContent = active.dataset.emoji || '';
          this.thumb.style.left = 'calc(' + (sliderProgress * 100) + '% + ' + (24 - sliderProgress * 48) + 'px)';
        }

        this.updateSwipeHint(cardIndex);
        if (scrollCard) this.scrollToCard(cardIndex);
      }
    });
  }

  if (!customElements.get('ka-home-rotator')) {
    customElements.define('ka-home-rotator', class extends HTMLElement {
      connectedCallback() {
        this.target = this.querySelector('[data-ka-rotator-word]');
        this.words = (this.dataset.words || '').split(/\r?\n/).map((word) => word.trim()).filter(Boolean);
        if (!this.target || this.words.length < 2) return;

        this.index = Math.max(this.words.indexOf(this.target.textContent.trim()), 0);
        this.interval = Math.max(Number(this.dataset.interval) || 2400, 800);
        this.onMotionChange = () => this.syncPlayback();
        reduceMotion.addEventListener('change', this.onMotionChange);
        this.syncPlayback();
      }

      syncPlayback() {
        this.stop();
        if (reduceMotion.matches) return;

        this.timer = window.setInterval(() => {
          this.target.classList.add('out');
          this.transitionTimer = window.setTimeout(() => {
            this.index = (this.index + 1) % this.words.length;
            this.target.textContent = this.words[this.index];
            this.target.classList.remove('out');
            this.target.classList.add('in');
            this.frame = window.requestAnimationFrame(() => {
              this.frame = window.requestAnimationFrame(() => this.target.classList.remove('in'));
            });
          }, 380);
        }, this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        window.clearTimeout(this.transitionTimer);
        window.cancelAnimationFrame(this.frame);
        this.timer = null;
        if (this.target) this.target.classList.remove('out', 'in');
      }

      disconnectedCallback() {
        this.stop();
        if (this.onMotionChange) reduceMotion.removeEventListener('change', this.onMotionChange);
      }
    });
  }

  if (!customElements.get('ka-home-stats')) {
    customElements.define('ka-home-stats', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        var figures = Array.from(this.querySelectorAll('[data-ka-count]'));
        if (!figures.length || reduceMotion.matches || !('IntersectionObserver' in window)) return;

        figures.forEach((element) => {
          var raw = element.dataset.kaCount || element.textContent;
          var match = raw.match(/^([^\d\-−]*)([\-−]?)([\d.]+)(.*)$/);
          if (!match) return;
          var prefix = match[1];
          var sign = match[2];
          var target = parseFloat(match[3]);
          var suffix = match[4];
          var decimals = (match[3].split('.')[1] || '').length;
          var observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            var startedAt = null;
            var duration = Number(this.dataset.duration || 900);
            var step = (timestamp) => {
              if (!startedAt) startedAt = timestamp;
              var progress = Math.min((timestamp - startedAt) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              element.textContent = prefix + sign + (target * eased).toFixed(decimals) + suffix;
              if (progress < 1) window.requestAnimationFrame(step);
            };
            element.textContent = prefix + sign + (0).toFixed(decimals) + suffix;
            window.requestAnimationFrame(step);
          }, { threshold: .6 });
          observer.observe(element);
        });
      }
    });
  }

  if (!customElements.get('ka-home-study')) {
    customElements.define('ka-home-study', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        if (this.dataset.animate !== 'true' || reduceMotion.matches || !('IntersectionObserver' in window)) {
          this.dataset.initialized = 'true';
          return;
        }
        var lines = Array.from(this.querySelectorAll('[data-ka-line]'));
        if (!lines.length) {
          // Upgraded before children were parsed (non-deferred script); retry once the DOM is complete.
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        this.dataset.initialized = 'true';
        // Size the dash to each line so the draw-in runs end to end regardless of chart values.
        lines.forEach((line) => {
          // Only the chart variant that is currently displayed can be measured; the other
          // (display: none at this breakpoint) is left undashed so it renders plain if the
          // viewport later crosses the breakpoint.
          var length = 0;
          try {
            if (line.getClientRects().length) length = Math.ceil(line.getTotalLength()) + 2;
          } catch (error) {
            length = 0;
          }
          if (!length) return;
          line.style.strokeDasharray = String(length);
          line.style.strokeDashoffset = String(length);
        });
        this.dataset.ready = 'true';
        var observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          window.requestAnimationFrame(() => {
            lines.forEach((line) => { line.style.strokeDashoffset = '0'; });
            this.classList.add('in-view');
          });
        }, { threshold: .45 });
        observer.observe(this);
      }
    });
  }

  if (!customElements.get('ka-home-scroll-gallery')) {
    customElements.define('ka-home-scroll-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        var rail = this.querySelector('[data-ka-scroll-rail]');
        if (this.dataset.nudge === 'false' || !rail || reduceMotion.matches || !('IntersectionObserver' in window)) return;
        var observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          window.setTimeout(() => rail.classList.add('hinted'), 320);
        }, { threshold: .45 });
        observer.observe(rail);
      }
    });
  }

  var parallaxItems = new Set();
  var ticking = false;

  function scanParallax(root) {
    if (reduceMotion.matches) return;
    root.querySelectorAll('[data-ka-parallax]').forEach((element) => {
      if (parallaxItems.has(element)) return;
      parallaxItems.add(element);
      element.style.willChange = 'transform';
    });
    requestFrame();
  }

  function renderParallax() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    parallaxItems.forEach((element) => {
      if (!element.isConnected) {
        parallaxItems.delete(element);
        return;
      }
      var rect = element.getBoundingClientRect();
      if (rect.bottom < -300 || rect.top > viewportHeight + 300) return;
      var progress = 1 - ((rect.top + rect.height / 2) / viewportHeight);
      var mode = element.dataset.kaParallax;
      var range = Number(element.dataset.range || 70);
      var inverse = element.dataset.inverse === 'true' ? -1 : 1;
      var base = element.dataset.base ? element.dataset.base + ' ' : '';

      if (mode === 'x') {
        element.style.transform = base + 'translateX(' + ((.5 - progress) * range).toFixed(1) + 'px)';
      } else if (mode === 'reveal') {
        var reveal = Math.min(Math.max((progress - .02) / .48, 0), 1);
        element.style.transform = 'rotate(' + (-30 * (1 - reveal)).toFixed(2) + 'deg) scale(' + (.88 + .12 * reveal).toFixed(3) + ')';
        element.style.opacity = (.4 + .6 * reveal).toFixed(2);
      } else {
        element.style.transform = base + 'translateY(' + ((progress - .5) * range * inverse).toFixed(1) + 'px)';
      }
    });
    ticking = false;
  }

  function requestFrame() {
    if (ticking || reduceMotion.matches) return;
    ticking = true;
    window.requestAnimationFrame(renderParallax);
  }

  scanParallax(document);
  window.addEventListener('scroll', requestFrame, { passive: true });
  window.addEventListener('resize', requestFrame, { passive: true });
  document.addEventListener('shopify:section:load', (event) => scanParallax(event.target));
})();
